import React, { useEffect, useState } from "react";
import LandingVideo, { ILandingVideoProps } from "../LandingVideo";
import { _MargauxMotinVideoRoot } from "./MargauxMotinVideo.styled"; 
import clsx from "clsx";
import DecorationBox from "../../../DecorationBox/DecorationBox";

interface IMargauxMotinVideoProps
  extends Omit<ILandingVideoProps, "onShowPlayerChange"> {}

const MargauxMotinVideo = (props: IMargauxMotinVideoProps) => {
  const { ...videoProps } = props;
  const [showPlayer, setShowPlayer] = useState(false);

  useEffect(() => {
    if (showPlayer) {
      setShowPlayer(true);
    }
  }, [showPlayer]);
  return (
    <_MargauxMotinVideoRoot>
      <LandingVideo
        {...videoProps}
        className="margaux-motin-video"
        onShowPlayerChange={setShowPlayer}
      />
      <DecorationBox
        imageName="maki"
        className={clsx("margaux-motin-video-decorations", {
          playerShown: showPlayer,
        })}
        enableAnimation={true}
        animationType="slideLeft"
        animationDelay={600}
        animationDistance={100}
        threshold={0.4}
      />
      <DecorationBox
        imageName="nigiri"
        className={clsx("margaux-motin-video-decorations-2", {
          playerShown: showPlayer,
        })}
        enableAnimation={true}
        animationType="slideUp"
        animationDelay={100}
        animationDistance={200}
        threshold={0.4}
      />
      <DecorationBox
        imageName="girlDogOnBike"
        className={clsx("margaux-motin-video-decorations-3", {
          playerShown: showPlayer,
        })}
        enableAnimation={true}
        animationType="slideRight"
        animationDelay={1000}
        animationDistance={400}
        threshold={0.4}
      />
    </_MargauxMotinVideoRoot>
  );
};

export default MargauxMotinVideo;
